import {baseUrl, execute} from "./ApiUtils";


const payments_base_url = baseUrl + "payments/"
const allTransactionsUrl = baseUrl + "payments/transactions";

export function payGame(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(`${payments_base_url}game/${gameId}/payment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }),
        successCallBack,
        errorCallBack)
}

export function getCurrentBalance(successCallBack, errorCallBack) {
    execute(
        () => fetch(payments_base_url + "currrent_balance", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), successCallBack, errorCallBack
    )
}

export function getGameRemainingPrice(gameId, successCallBack, errorCallBack) {
    execute(
        () => fetch(`${payments_base_url}game/${gameId}/remaining_price`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), successCallBack, errorCallBack
    )
}

export function getAllPaymentTransactions(callback, error) {
    execute(
        () => fetch(allTransactionsUrl, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}